import { createContext, useContext, useState } from 'react';
import { createStore as createZustandStore, useStore } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { jsx as _jsx } from "react/jsx-runtime";
export * from 'zustand';
export const createStore = (initializer, options = {}) => {
  const store = createZustandStore()(devtools(subscribeWithSelector(immer(initializer)), options.devtools));
  return store;
};
export const createZustandStoreContext = () => {
  const Context = /*#__PURE__*/createContext(null);
  function useThisStore(selector) {
    const storeFromContext = useContext(Context);
    if (storeFromContext === null) {
      throw new Error('Store must be used within its ContextProvider');
    }
    return useStore(storeFromContext, selector);
  }
  const ContextProvider = props => {
    var _ref, _props$store;
    const [storeInstance] = useState(() => {
      var _props$initializeStor;
      return (_props$initializeStor = props.initializeStore) === null || _props$initializeStor === void 0 ? void 0 : _props$initializeStor.call(props);
    });
    return /*#__PURE__*/_jsx(Context.Provider, {
      value: (_ref = (_props$store = props.store) !== null && _props$store !== void 0 ? _props$store : storeInstance) !== null && _ref !== void 0 ? _ref : null,
      children: props.children
    });
  };
  return {
    useStore: useThisStore,
    ContextProvider
  };
};